// Generated JSON contract is owned by accounting-backend. No endpoint is enabled here.
import contract from './MatchingService.contract.json';
export const bankReconciliationContract = contract;
export const supportsBankReconciliation = capabilities =>
    Array.isArray(capabilities?.contracts) && capabilities.contracts.includes(contract.contract);
